import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from 'i18next-http-backend';
import en from "./assets/locales/en/translation.json"
import vi from "./assets/locales/vi/translation.json"
import i18n from "i18next";

const resources = {
    en: {
        translation: en
    },
    vi: {
        translation: vi
    }
}

const setCookie = (
    name,
    value,
    options = {}
) => {
    if (options.expires) {
        options.expires = options.expires.toUTCString();
    }
    let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(
        value
    )}`;
    for (const [key, val] of Object.entries(options)) {
        updatedCookie += `; ${key}`;
        if (val !== true) {
            updatedCookie += `=${val}`;
        }
    }
    document.cookie = updatedCookie;
};

let lang = null;

if (typeof window.localStorage === "object" && typeof window.localStorage?.getItem !== 'undefined') {
    // Ưu tiên key `lang` (vd: từ trang marketing) để đồng bộ i18next
    const storedLang = localStorage.getItem("lang");
    if (storedLang === "vi" || storedLang === "en") {
        lang = storedLang;
        localStorage.setItem("i18nextLng", lang);
        localStorage.setItem("i18nextLngId", lang === "vi" ? "1" : "2");
    } else {
        lang = localStorage.getItem("i18nextLng");
    }
}

if (!lang) {
    lang = "en"
    if (typeof window.localStorage === "object" && typeof window.localStorage?.getItem !== 'undefined') {
        localStorage.setItem("i18nextLng", lang)
        localStorage.setItem("i18nextLngId", "2")
       
        // // const 
        // setCookie("lang", lang === 'en' ? '2' : '1', {
        //     expires: new Date(Date.now() + 31536000 * 1000),
        //     path: "/",
        // });
    }
    else {
        console.error("localStorage is not available");
    }
} else if (typeof window.localStorage === "object" && typeof window.localStorage?.getItem !== 'undefined') {
    // Đảm bảo i18nextLngId luôn khớp với i18nextLng
    const normalizedLang = lang.startsWith("vi") ? "vi" : "en";
    if (!localStorage.getItem("i18nextLngId")) {
        localStorage.setItem("i18nextLngId", normalizedLang === "vi" ? "1" : "2");
    }
}

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .use(Backend)
    .init({
        // debug : true,
        fallbackLng: "en",
        resources,
        detection: {
            order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage']
        },
        interpolation: {
            escapeValue: false // not needed for react as it escapes by default
        }
    })

export default i18n;

